// assets/kc-warranty-crosssell-popup.js
//
// Cross-sell popup shown on the PDP after an add-to-cart lands in the real
// cart (polling /cart.js and diffing line-item keys, rather than assuming
// the add succeeded — a sold-out or rejected add never shows a false
// "Agregado a tu carro"). Recommendations come from Bloomreach via
// exponea.getRecommendation(), with the block resolved via the
// cross_sell_rule metaobject (SKU > product_type > default).
//
// Este theme además incluye el GATE de garantía extendida / instalación: si
// el producto ofrece esos bloques y el cliente agrega sin marcar ninguno,
// main-product.liquid dispara 'kc:warranty-gate' y acá se abre un modal que
// mueve los bloques reales de la PDP adentro para que elija. Al cerrarse
// reenvía el add-to-cart y encadena el cross-sell.
// Kill-switch: GATE_TEMP_DISABLED = true deja pasar el add sin mostrarlo.
(function () {
  var CROSS_OVERLAY_ID = 'kc-crosssell-only-overlay';
  var GATE_OVERLAY_ID = 'kc-warranty-overlay';

  // Kill-switch del gate sin tocar el resto del archivo: en true el popup de
  // garantía/instalación no se muestra y el add-to-cart sigue de largo (el
  // cross-sell se muestra igual).
  var GATE_TEMP_DISABLED = false;

  // Default Bloomreach recommendation block. The legacy wl-cart banner picks
  // a more specific block per SKU/product_type via a Jinja if/elif chain that
  // lives in Bloomreach, not here — pending migration to a shared config.
  var CROSS_SELL_RECOMMENDATION_ID = '66352684297c0740595ada76';
  var CROSS_SELL_SIZE = 8;
  // Same event/shape the site's other carousels track, so this popup's clicks
  // land next to theirs in Bloomreach reports.
  var CROSS_SELL_CARRUSEL_NAME = 'Cross - Add to Cart';

  // Rules come from the cross_sell_rule metaobject, rendered by
  // main-product.liquid into a JSON <script> tag. Cached after first read.
  // Falls back to CROSS_SELL_RECOMMENDATION_ID whenever the tag is missing,
  // empty, or fails to parse — the popup must never end up with no block.
  var _crossSellRulesCache = null;
  function getCrossSellRules() {
    if (_crossSellRulesCache) return _crossSellRulesCache;
    var rules = [];
    try {
      var el = document.getElementById('kc-cross-sell-rules');
      if (el && el.textContent) {
        var parsed = JSON.parse(el.textContent);
        if (Array.isArray(parsed)) rules = parsed;
      }
    } catch (e) {
      rules = [];
    }
    _crossSellRulesCache = rules;
    return rules;
  }

  // SKU rules always outrank product_type rules, regardless of order in the
  // metaobject — matches how the equivalent Bloomreach Jinja is meant to work.
  function resolveCrossSellRecommendationId(item) {
    var rules = getCrossSellRules();
    if (!rules.length) return CROSS_SELL_RECOMMENDATION_ID;

    var sku = item && item.sku;
    var productType = item && item.product_type;

    if (sku) {
      for (var i = 0; i < rules.length; i++) {
        var r = rules[i];
        if (r.match_type === 'sku' && Array.isArray(r.skus) && r.skus.indexOf(sku) !== -1) {
          return r.recommendation_id || CROSS_SELL_RECOMMENDATION_ID;
        }
      }
    }
    if (productType) {
      for (var j = 0; j < rules.length; j++) {
        var rt = rules[j];
        if (rt.match_type === 'product_type' && Array.isArray(rt.product_types) && rt.product_types.indexOf(productType) !== -1) {
          return rt.recommendation_id || CROSS_SELL_RECOMMENDATION_ID;
        }
      }
    }
    for (var k = 0; k < rules.length; k++) {
      if (rules[k].match_type === 'default') return rules[k].recommendation_id || CROSS_SELL_RECOMMENDATION_ID;
    }
    return CROSS_SELL_RECOMMENDATION_ID;
  }

  /* ------------------------------------------------------------------ */
  /* Shared helpers                                                      */
  /* ------------------------------------------------------------------ */

  var scrollLockCount = 0;
  var savedBodyOverflow = '';
  function lockScroll() {
    if (scrollLockCount === 0) {
      savedBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    scrollLockCount++;
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) document.body.style.overflow = savedBodyOverflow;
  }

  // Keeps the Bloomreach "wl-cart" banner hidden while the popup is open,
  // then restores it. subtree:true because the SDK injects nested, and we
  // sweep already-present nodes since the banner may predate the popup.
  function holdWlCartBanner() {
    var held = [];

    function hide(node) {
      if (held.indexOf(node) !== -1) return;
      held.push(node);
      node.style.setProperty('opacity', '0', 'important');
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
    }

    Array.prototype.forEach.call(document.querySelectorAll('.wl-cart'), hide);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        Array.prototype.forEach.call(m.addedNodes, function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('wl-cart')) hide(node);
          if (node.querySelectorAll) {
            Array.prototype.forEach.call(node.querySelectorAll('.wl-cart'), hide);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return function release() {
      observer.disconnect();
      held.forEach(function (node) {
        node.style.removeProperty('opacity');
        node.style.removeProperty('visibility');
        node.style.removeProperty('pointer-events');
      });
      held = [];
    };
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function cartKeys(cart) {
    var map = {};
    (cart.items || []).forEach(function (i) {
      map[i.key] = i.quantity;
    });
    return map;
  }

  // Polls the real cart until a new/increased line item shows up, then hands
  // back the item that was actually added. Resolves null on timeout so a
  // failed add simply shows nothing rather than a false confirmation.
  function waitForCartAddition(beforeKeys, preferVariantId, timeoutMs) {
    var deadline = Date.now() + (timeoutMs || 6000);

    function attempt() {
      return fetchCart()
        .then(function (cart) {
          var added = [];
          (cart.items || []).forEach(function (item) {
            var prev = beforeKeys[item.key];
            if (prev === undefined || item.quantity > prev) added.push(item);
          });

          var found = null;
          if (added.length) {
            if (preferVariantId) {
              added.forEach(function (item) {
                if (!found && String(item.variant_id) === String(preferVariantId)) found = item;
              });
            }
            if (!found) {
              added.forEach(function (item) {
                if (!found && item.product_type !== 'Warranty') found = item;
              });
            }
            if (!found) found = added[0];
          }
          if (found) return found;
          if (Date.now() >= deadline) return null;
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(attempt());
            }, 400);
          });
        })
        .catch(function () {
          return null;
        });
    }
    return attempt();
  }

  // Recommendation feeds are external input — only allow real http(s) links.
  function safeUrl(url) {
    if (!url) return null;
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return null;
      return parsed.href;
    } catch (e) {
      return null;
    }
  }

  function formatPrice(n) {
    return '$' + Math.round(n).toLocaleString('es-CL');
  }

  function buildCloseButton(className) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = className;
    btn.setAttribute('aria-label', 'Cerrar');
    btn.innerHTML =
      '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
    return btn;
  }

  // Wires Escape-to-close and restores focus to whatever the customer was on
  // before the popup stole it.
  function attachDismissBehaviour(overlay, onDismiss) {
    var previouslyFocused = document.activeElement;

    function onKeydown(e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        onDismiss();
      }
    }
    document.addEventListener('keydown', onKeydown);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) onDismiss();
    });

    return function cleanup() {
      document.removeEventListener('keydown', onKeydown);
      if (previouslyFocused && previouslyFocused.focus) {
        try {
          previouslyFocused.focus();
        } catch (e) {
          /* element may be gone — harmless */
        }
      }
    };
  }

  function mountOverlay(overlay) {
    document.body.appendChild(overlay);
    lockScroll();
    // Force a style flush before .active so the transition plays. Deliberately
    // not requestAnimationFrame: some embedded webviews throttle rAF and would
    // leave the popup stuck at opacity:0.
    void overlay.offsetHeight;
    overlay.classList.add('active');
  }

  function unmountOverlay(overlay, onDone) {
    overlay.classList.remove('active');
    unlockScroll();
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      if (onDone) onDone();
    }, 250);
  }

  /* ------------------------------------------------------------------ */
  /* Gate popup: garantía extendida / instalación                        */
  /* ------------------------------------------------------------------ */

  // Lo dispara main-product.liquid cuando el producto ofrece bloques de
  // garantía/instalación y el cliente pulsó "Agregar al carro" sin marcar
  // ninguno. En vez de reconstruir las opciones (precios, variantes, textos),
  // se MUEVEN los nodos reales .product-bundle-block al modal y se devuelven
  // al cerrar: lo que ve el cliente siempre coincide con lo que Liquid rindió
  // para la variante actual, sin duplicar datos en JS.
  var GATE_ASIDE_IMAGE =
    'https://cdn.shopify.com/s/files/1/0104/4391/5319/files/instalacion-campanas-fdv-kubli-smeg-kitchen-center.webp?v=1760017021&width=800';

  // Mismo evento que el cross-sell (click_carrusel) para que las metricas del
  // gate caigan en los reportes que el equipo ya mira, con carrusel_name
  // propio para poder separarlas.
  var GATE_CARRUSEL_NAME = 'Gate Garantia + Instalacion';

  var GATE_BLOCK_EXPLANATIONS = {
    'Garantía Extendida': 'Reparación o reemplazo sin costo una vez terminada la garantía del fabricante.',
    'Servicio de Instalación': 'Un técnico lo instala en tu domicilio y lo deja listo para usar.',
  };

  document.addEventListener('kc:warranty-gate', function (evt) {
    var form = evt.detail && evt.detail.form;
    if (!form) return;
    if (document.getElementById(GATE_OVERLAY_ID) || document.getElementById(CROSS_OVERLAY_ID)) return;

    if (GATE_TEMP_DISABLED) {
      resumeAddToCart(form, false);
      return;
    }

    // Solo bloques visibles y con opciones reales: garantia-variant-sync.js
    // oculta el bloque entero cuando la variante elegida no tiene garantía.
    var blocks = Array.prototype.filter.call(document.querySelectorAll('.product-bundle-block'), function (block) {
      return block.style.display !== 'none' && block.querySelector('.product-bundle__item');
    });

    // Nada real que ofrecer — nunca bloquear la compra por un modal vacío.
    if (!blocks.length) {
      resumeAddToCart(form, false);
      return;
    }

    var placeholders = blocks.map(function (block) {
      var placeholder = document.createComment('kc-warranty-slot');
      block.parentNode.insertBefore(placeholder, block);
      return placeholder;
    });

    // Idempotente y defensivo: si el theme re-rindió la sección mientras
    // teníamos los nodos, el placeholder quedó desconectado. Devolver el
    // bloque a cualquier parte es mejor que lanzar acá — una excepción se
    // saltaría el teardown y dejaría al cliente sin poder comprar.
    var restored = false;
    function restoreBlocks() {
      if (restored) return;
      restored = true;
      blocks.forEach(function (block, i) {
        var placeholder = placeholders[i];
        try {
          if (placeholder && placeholder.parentNode) {
            placeholder.parentNode.insertBefore(block, placeholder);
            placeholder.parentNode.removeChild(placeholder);
          } else if (block.parentNode) {
            block.parentNode.removeChild(block);
          }
        } catch (e) {
          /* jamás romper el flujo de compra por restaurar el DOM */
        }
      });
    }

    var releaseWlCart = holdWlCartBanner();

    // showPopup() de main-product.liquid abre el modal de términos al
    // seleccionar; dentro del gate eso apilaría un segundo popup. El link
    // "Revisar Términos y Condiciones" de cada item sigue funcionando.
    var originalShowPopup = window.showPopup;
    window.showPopup = function () {};

    var overlay = document.createElement('div');
    overlay.className = 'kcw-overlay';
    overlay.id = GATE_OVERLAY_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Opciones de protección para tu compra');

    var modal = document.createElement('div');
    modal.className = 'kcw-modal';

    var closeBtn = buildCloseButton('kcw-close');

    var scroll = document.createElement('div');
    scroll.className = 'kcw-scroll';

    var split = document.createElement('div');
    split.className = 'kcw-split';

    var aside = document.createElement('div');
    aside.className = 'kcw-aside';
    aside.style.backgroundImage =
      'linear-gradient(to bottom, rgba(51,51,51,0.72) 0%, rgba(51,51,51,0.18) 55%, rgba(51,51,51,0.08) 100%), url("' +
      GATE_ASIDE_IMAGE +
      '")';
    aside.innerHTML =
      '<p class="kcw-aside__kicker">Antes de agregar</p>' +
      '<h2 class="kcw-aside__title">Compra con respaldo.</h2>' +
      '<p class="kcw-aside__sub">Instalación por técnico certificado y garantía más allá del fabricante.</p>';

    var main = document.createElement('div');
    main.className = 'kcw-main';

    var addedRow = buildPdpProductRow();
    if (addedRow) main.appendChild(addedRow);

    // El header de cada bloque queda oculto (.product-bundle__header con
    // display:none — su onclick alterna un acordeón que nuestro CSS ya fuerza
    // abierto, dejando el icono "+"/"×" desincronizado). En su lugar se rinde
    // un título estático + explicación corta por bloque, para que Garantía
    // Extendida e Instalación no se mezclen visualmente.
    blocks.forEach(function (block) {
      var titleEl = block.querySelector('.product-bundle__title');
      var titleText = titleEl ? titleEl.textContent.trim() : '';

      var section = document.createElement('div');
      section.className = 'kcw-block';

      if (titleText) {
        var heading = document.createElement('h3');
        heading.className = 'kcw-block__title';
        heading.textContent = titleText;
        section.appendChild(heading);

        var explainText = GATE_BLOCK_EXPLANATIONS[titleText];
        if (explainText) {
          var explain = document.createElement('p');
          explain.className = 'kcw-block__explain';
          explain.textContent = explainText;
          section.appendChild(explain);
        }
      }

      // Varias opciones = tiles comparables en grilla (garantía: +2 / +4 años);
      // una sola = fila ancha (instalación). Se decide por cantidad y no por el
      // título ni el tipo de input: ambos bloques usan radio, así que el tipo
      // no distingue, y el copy del admin puede cambiar.
      var optionCount = block.querySelectorAll('.product-bundle__item').length;
      block.classList.add(optionCount > 1 ? 'kcw-bundle--tiles' : 'kcw-bundle--rows');

      // Cada item repite el nombre del bloque ("Garantía Extendida") y agrega
      // el título de variante ("2 años"). Como el título del bloque ya lo
      // rendimos una vez arriba, marcamos qué línea sirve de nombre visible:
      // la variante, salvo cuando es el "Default Title" de un producto de una
      // sola variante (típico en instalación), donde no dice nada.
      Array.prototype.forEach.call(block.querySelectorAll('.product-bundle__item'), function (item) {
        var variantName = item.querySelector('.product-bundle__variant-name');
        var variantText = variantName ? variantName.textContent.trim() : '';
        var useVariant = variantText && variantText.toLowerCase() !== 'default title';
        item.classList.add(useVariant ? 'kcw-item--variant-name' : 'kcw-item--product-name');
        item.dataset.kcwBlock = titleText; // para nombrar el servicio en el tracking
      });

      // Forzar el acordeón abierto: dentro del popup no hay razón para
      // esconder las opciones detrás de un "+".
      var content = block.querySelector('[id^="content-"]');
      var toggle = block.querySelector('[id^="toggle-"]');
      if (content) content.classList.add('expanded');
      if (toggle) {
        toggle.classList.add('expanded');
        toggle.textContent = '×';
      }

      section.appendChild(block);
      main.appendChild(section);
    });

    split.appendChild(aside);
    split.appendChild(main);
    scroll.appendChild(split);

    var foot = document.createElement('div');
    foot.className = 'kcw-foot';

    var totalWrap = document.createElement('div');
    totalWrap.className = 'kcw-foot__total';
    var totalLabel = document.createElement('span');
    totalLabel.className = 'kcw-foot__label';
    totalLabel.textContent = 'Total';
    var totalValue = document.createElement('span');
    totalValue.className = 'kcw-foot__value';
    totalWrap.appendChild(totalLabel);
    totalWrap.appendChild(totalValue);

    var actions = document.createElement('div');
    actions.className = 'kcw-foot__actions';

    var skipBtn = document.createElement('button');
    skipBtn.type = 'button';
    skipBtn.className = 'kcw-btn-link';
    skipBtn.textContent = 'Sin protección';

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'kcw-btn-primary';
    addBtn.textContent = 'Agregar al carro';
    // Arranca apagado: sin nada marcado este botón haría lo mismo que "Sin
    // protección", y tener dos caminos que agregan el producto pelado deja la
    // sensación de que el modal no sirvió para nada. Salir sin servicios es
    // una decisión explícita, y para eso está el link de al lado.
    addBtn.disabled = true;

    actions.appendChild(skipBtn);
    actions.appendChild(addBtn);
    foot.appendChild(totalWrap);
    foot.appendChild(actions);

    modal.appendChild(closeBtn);
    modal.appendChild(scroll);
    modal.appendChild(foot);
    overlay.appendChild(modal);

    mountOverlay(overlay);
    closeBtn.focus();

    var gateProductName = pdpTitle();
    var gateVariantId = mainVariantOf(form);
    function track(interes, data) {
      data = data || {};
      data.productName = gateProductName;
      data.itemId = gateVariantId;
      trackGate(interes, data);
    }

    // Que hay marcado ahora: sirve para el evento de confirmacion y tambien
    // para saber si alguien eligio algo y aun asi salio sin proteccion.
    function selectedSummary() {
      var labels = [];
      var total = 0;
      Array.prototype.forEach.call(main.querySelectorAll('.product-bundle__checkbox:checked'), function (input) {
        var item = input.closest('.product-bundle__item');
        if (!item) return;
        labels.push(gateServiceLabel(item));
        total += bundleItemPrice(item);
      });
      return { servicio: labels.join(' + '), servicio_valor: total, servicios_count: labels.length };
    }

    track('view');

    // Una vez por opcion: el recalculo corre en cada cambio y en cada tap, y
    // sin esto un radio ya marcado volveria a emitir el evento.
    var trackedSelection = {};

    var basePrice = pdpBasePrice();

    function recalcTotal() {
      var extra = 0;
      var count = 0;
      Array.prototype.forEach.call(main.querySelectorAll('.product-bundle__checkbox:checked'), function (input) {
        var item = input.closest('.product-bundle__item');
        var price = item ? bundleItemPrice(item) : 0;
        extra += price;
        if (price > 0) count++;

        var variantId = input.dataset.variantId || '';
        if (item && variantId && !trackedSelection[variantId]) {
          trackedSelection[variantId] = true;
          track('select', { servicio: gateServiceLabel(item), servicio_valor: price, servicios_count: 1 });
        }
      });
      addBtn.disabled = count === 0;
      totalValue.textContent = formatPrice(basePrice + extra);
      totalLabel.textContent =
        count === 0 ? 'Total' : count === 1 ? 'Total · 1 servicio' : 'Total · ' + count + ' servicios';

      // Clase explícita en vez de :has(), que los WebView viejos de Android no
      // soportan — sin esto la tarjeta elegida pierde el resaltado.
      Array.prototype.forEach.call(main.querySelectorAll('.product-bundle__item'), function (item) {
        var input = item.querySelector('.product-bundle__checkbox');
        item.classList.toggle('kcw-is-selected', !!(input && input.checked));
      });
    }

    main.addEventListener('change', recalcTotal);
    main.addEventListener('click', function () {
      // El theme alterna los inputs con un handler delegado en captura; releer
      // en el próximo tick para que el total siga también a los taps sobre la
      // tarjeta completa.
      setTimeout(recalcTotal, 0);
    });
    recalcTotal();

    var detachDismiss = attachDismissBehaviour(overlay, function () {
      proceed(false, 'dismiss');
    });

    // Un cambio de variante re-rinde justo los nodos que tenemos prestados
    // (garantia-variant-sync.js). En vez de dejar que las opciones muten bajo
    // el cliente a mitad de decisión, cerrar limpio y que elija de nuevo.
    var unsubscribeVariant = subscribeSafely('variantChange', function () {
      if (!document.getElementById(GATE_OVERLAY_ID)) return;
      finish();
    });

    var finished = false;
    function finish(onDone) {
      if (finished) return;
      finished = true;
      window.showPopup = originalShowPopup;
      releaseWlCart();
      detachDismiss();
      if (unsubscribeVariant) unsubscribeVariant();
      try {
        restoreBlocks();
      } finally {
        unmountOverlay(overlay, onDone);
      }
    }

    function proceed(withSelection, motivo) {
      if (finished) return;
      // Antes de desmarcar: asi "skip" reporta lo que el cliente llego a
      // elegir y termino descartando, que es justo la senal interesante.
      track(motivo || (withSelection ? 'add' : 'skip'), selectedSummary());
      if (!withSelection) {
        // Salir sin protección tiene que dejar el producto solo: si el cliente
        // alcanzó a marcar algo y luego eligió "Sin protección", el listener
        // de main-product.liquid vería esos checkboxes marcados y agregaría
        // los servicios igual.
        Array.prototype.forEach.call(main.querySelectorAll('.product-bundle__checkbox:checked'), function (input) {
          input.checked = false;
        });
      }
      finish(function () {
        resumeAddToCart(form, withSelection);
      });
    }

    addBtn.addEventListener('click', function () {
      proceed(true, 'add');
    });
    skipBtn.addEventListener('click', function () {
      proceed(false, 'skip');
    });
    // X / Esc / click afuera se reportan aparte de "Sin proteccion": rechazar
    // a proposito y cerrar la ventana no significan lo mismo.
    closeBtn.addEventListener('click', function () {
      proceed(false, 'dismiss');
    });
  });

  // Continúa el add-to-cart que el gate interceptó y encadena el cross-sell.
  //
  // withSelection=true reenvía el form: el listener de main-product.liquid ve
  // los checkboxes marcados, corta el submit y hace su propio POST con el
  // producto + los servicios. Ese camino nunca llega a Dawn.
  //
  // withSelection=false NO puede reenviar el form. Sin nada marcado el submit
  // sigue de largo hasta el <product-form> de Dawn, y en esta ficha hay más de
  // uno: el que no tiene botón propio hace preventDefault() y enseguida revienta
  // con "Cannot read properties of null (reading 'getAttribute')" sobre
  // this.submitButton, así que el producto no se agrega nunca. Reproducido con
  // requestSubmit() directo, sin abrir el modal. Por eso el producto solo se
  // agrega acá, con el mismo POST que usa el theme en el otro camino.
  function resumeAddToCart(form, withSelection) {
    var beforeKeysPromise = fetchCart()
      .then(cartKeys)
      .catch(function () {
        return {};
      });
    var mainVariantId = mainVariantOf(form);

    beforeKeysPromise.then(function (beforeKeys) {
      waitForCartAddition(beforeKeys, mainVariantId).then(function (addedItem) {
        if (addedItem) showCrossSellPopup(addedItem);
      });
    });

    if (withSelection) {
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
      return;
    }

    if (!mainVariantId) {
      // Sin variante no hay nada que postear; devolver el submit al theme es
      // peor que no hacer nada, pero al menos deja rastro de por qué.
      form.dataset.kcWarrantyBypass = '1';
      if (form.requestSubmit) form.requestSubmit();
      return;
    }

    var quantity = 1;
    try {
      var qtyInput = form.querySelector('[name="quantity"]');
      if (qtyInput && qtyInput.value) quantity = parseInt(qtyInput.value, 10) || 1;
    } catch (e) {
      quantity = 1;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      // kc-add-cart-event.js lee este header para el campo "origen" de add_cart.
      headers: { 'Content-Type': 'application/json', 'X-KC-Origen': 'gate_sin_servicios' },
      body: JSON.stringify({
        items: [{ id: mainVariantId, quantity: quantity }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (payload) {
        syncCartUi(payload);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () {
        /* el sondeo de waitForCartAddition decide si hubo agregado real */
      });
  }

  // Mismo evento y mismas claves que trackCrossSellClick, para que los dos
  // popups se puedan comparar en el mismo reporte de Bloomreach.
  // interes: view (se mostro) | select (marco una opcion) | add (confirmo con
  // servicios) | skip ("Sin proteccion") | dismiss (X, Esc o click afuera).
  function trackGate(interes, data) {
    if (typeof exponea === 'undefined' || typeof exponea.track !== 'function') return;
    try {
      data = data || {};
      exponea.track('click_carrusel', {
        'ubicación': 'PDP',
        carrusel_name: GATE_CARRUSEL_NAME,
        'interés': interes,
        product_name: data.productName || '',
        item_id: data.itemId || '',
        servicio: data.servicio || '',
        servicio_valor: data.servicio_valor || 0,
        servicios_count: data.servicios_count || 0,
      });
    } catch (e) {
      /* el tracking nunca puede romper la compra */
    }
  }

  // "Garantía Extendida · +2 Años Garantía". El nombre visible depende de
  // que linea quedo como tal (ver kcw-item--variant-name / --product-name).
  function gateServiceLabel(item) {
    var blockTitle = (item.dataset.kcwBlock || '').trim();
    var nameEl = item.classList.contains('kcw-item--variant-name')
      ? item.querySelector('.product-bundle__variant-name')
      : item.querySelector('.product-bundle__product-name');
    var name = nameEl ? nameEl.textContent.trim().replace(/\s+/g, ' ') : '';
    var label = name && name !== blockTitle ? (blockTitle ? blockTitle + ' · ' + name : name) : blockTitle || name;
    return label.slice(0, 80);
  }

  function pdpTitle() {
    var scope = document.querySelector('[id^="ProductInfo-"], [id^="MainProduct-"]') || document;
    var titleEl = scope.querySelector('h1') || document.querySelector('h1');
    return titleEl ? titleEl.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  // Precio del producto de la PDP (el que se está agregando), leído del DOM
  // porque en el gate el carro todavía no tiene la línea.
  function pdpBasePrice() {
    var scope = document.querySelector('[id^="ProductInfo-"], [id^="MainProduct-"]') || document;
    var priceWrap = scope.querySelector('.price');
    var priceEl = null;
    if (priceWrap && !priceWrap.classList.contains('price--on-sale')) {
      priceEl = priceWrap.querySelector('.price-item--regular');
    } else if (priceWrap) {
      priceEl = priceWrap.querySelector('.price-item--sale');
    }
    if (!priceEl) priceEl = scope.querySelector('.price-item--regular');
    return priceEl ? parseMoney(priceEl.textContent) : 0;
  }

  function bundleItemPrice(item) {
    var el =
      item.querySelector('.product-bundle__price-sale') || item.querySelector('.product-bundle__price-current');
    return el ? parseMoney(el.textContent) : 0;
  }

  // Formato es-CL: el punto separa miles y la coma decimales ("$16.990").
  function parseMoney(text) {
    if (!text) return 0;
    var match = String(text).replace(/\s/g, '').match(/[\d.,]+/);
    if (!match) return 0;
    var value = parseFloat(match[0].replace(/\./g, '').replace(',', '.'));
    return isNaN(value) ? 0 : value;
  }

  // Fila "Estás agregando": imagen, nombre y precio del producto de la PDP.
  function buildPdpProductRow() {
    var imgEl = document.querySelector('.product__media img, .media img');

    // pdpTitle() lee el h1 y no .product__title: ese contenedor trae el h1 y
    // además un <a><h2> con el mismo texto, y textContent los duplicaba.
    var title = pdpTitle();
    if (!title) return null;

    var price = pdpBasePrice();

    var row = document.createElement('div');
    row.className = 'kcw-added';

    var img = document.createElement('img');
    img.className = 'kcw-added__img';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    if (imgEl) img.src = imgEl.currentSrc || imgEl.src;

    var copy = document.createElement('div');
    copy.className = 'kcw-added__copy';

    var name = document.createElement('span');
    name.className = 'kcw-added__name';
    name.textContent = title;

    var meta = document.createElement('span');
    meta.className = 'kcw-added__meta';
    meta.textContent = 'Estás agregando' + (price ? ' · ' + formatPrice(price) : '');

    copy.appendChild(name);
    copy.appendChild(meta);
    row.appendChild(img);
    row.appendChild(copy);
    return row;
  }

  // subscribe/PUB_SUB_EVENTS son del theme y pueden cargar después que este
  // asset; reintentar en vez de perder el aviso de cambio de variante.
  function subscribeSafely(eventKey, callback, attempt) {
    attempt = attempt || 0;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS[eventKey]) {
      if (attempt > 40) return null; // ~2s de reintentos, después se rinde en silencio
      var handle = { fn: null };
      window.setTimeout(function () {
        handle.fn = subscribeSafely(eventKey, callback, attempt + 1);
      }, 50);
      return function () {
        if (handle.fn) handle.fn();
      };
    }
    return subscribe(PUB_SUB_EVENTS[eventKey], callback);
  }

  /* ------------------------------------------------------------------ */
  /* Trigger: detect a successful add-to-cart on the PDP's own form      */
  /* ------------------------------------------------------------------ */

  // Detected here rather than in main-product.liquid: that file's own submit
  // listener is bound ~1s after DOMContentLoaded to the forms present at that
  // moment, so on templates where the form is re-rendered afterwards it ends
  // up attached to a detached node. Delegation on `document` always matches
  // whatever form is live at submit time.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (!isMainProductForm(form)) return; // ignore quick-adds in carousels/drawer
      // Productos con bloques de garantía extendida / instalación siguen su
      // propio flujo inline (fetch directo a /cart/add.js cuando hay algo
      // marcado, o el submit nativo del form si no hay nada marcado) — este
      // listener nunca llama preventDefault/stopPropagation, así que no
      // interfiere con ese flujo. Solo observa el carrito real en paralelo
      // para saber si el agregado terminó pasando, sin importar el mecanismo,
      // y mostrar el cross-sell en ese caso. (Antes se saltaba por completo
      // cualquier producto con checkboxes de bundle, asumiendo que el gate
      // se encargaría de esto — pero producción no tiene gate, así que el
      // cross-sell nunca se disparaba para esos productos.)
      var mainVariantId = mainVariantOf(form);
      fetchCart()
        .then(cartKeys)
        .catch(function () {
          return {};
        })
        .then(function (beforeKeys) {
          return waitForCartAddition(beforeKeys, mainVariantId);
        })
        .then(function (addedItem) {
          if (addedItem) showCrossSellPopup(addedItem);
        });
    },
    true
  );

  function mainVariantOf(form) {
    var input = form && form.querySelector('[name="id"]');
    return input && input.value ? input.value : null;
  }

  // Only the PDP's own add-to-cart should trigger the popup — otherwise a
  // quick-add inside a "recommended products" carousel on the same page would
  // pop up confirming the wrong product.
  function isMainProductForm(form) {
    if (form.closest('cart-drawer, .cart-drawer, quick-add-modal, .quick-add-modal, .card, .kcb-right')) {
      return false;
    }
    return !!form.closest('.product, [id^="MainProduct-"], [id^="ProductInfo-"], .product-form-sticky, sticky-add-to-cart');
  }

  /* ------------------------------------------------------------------ */
  /* Popup: "Propuesta B" — confirmación + carrusel vertical             */
  /* ------------------------------------------------------------------ */

  // Columna izquierda de confirmación (imagen, nombre, precio, CTA al carro)
  // + columna derecha con el carrusel vertical de cross-sell. La confirmación
  // por sí sola ya es útil (foto real del producto + link al carro), así que
  // si Bloomreach no trae recomendaciones no se cierra el popup: solo se
  // oculta la columna derecha y la izquierda pasa a ocupar el ancho completo.
  function showCrossSellPopup(addedItem) {
    if (document.getElementById(CROSS_OVERLAY_ID) || document.getElementById(GATE_OVERLAY_ID)) return;

    var releaseWlCart = holdWlCartBanner();

    var overlay = document.createElement('div');
    overlay.className = 'kcb-overlay';
    overlay.id = CROSS_OVERLAY_ID;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Producto agregado al carro');

    var modal = document.createElement('div');
    modal.className = 'kcb-modal';

    var closeBtn = buildCloseButton('kcb-close');

    var scroll = document.createElement('div');
    scroll.className = 'kcb-scroll';

    var split = document.createElement('div');
    split.className = 'kcb-split';

    var left = buildConfirmPanel(addedItem);
    var cross = buildCrossSellPanel();

    split.appendChild(left);
    split.appendChild(cross.el);
    scroll.appendChild(split);
    modal.appendChild(closeBtn);
    modal.appendChild(scroll);
    overlay.appendChild(modal);

    mountOverlay(overlay);
    closeBtn.focus();

    var closed = false;
    var detachDismiss = attachDismissBehaviour(overlay, close);

    function close() {
      if (closed) return;
      closed = true;
      releaseWlCart();
      detachDismiss();
      cross.destroy();
      unmountOverlay(overlay);
    }

    closeBtn.addEventListener('click', close);

    loadCrossSell(cross, addedItem, function hasNoItems() {
      // El timeout de loadCrossSell (6s) puede disparar después de que el
      // usuario ya cerró el popup a mano — no tocar un split ya descartado.
      if (closed) return;
      // Sin recomendaciones: la columna izquierda (imagen + "Ir al carro")
      // sigue siendo útil por sí sola, así que no cerramos el popup — solo
      // se queda sin la segunda columna.
      split.classList.add('kcb-split--single');
    });
  }

  // Construida a partir del line item real del carrito (no del DOM de la
  // PDP), así que la imagen/nombre/precio siempre corresponden a lo que
  // efectivamente se agregó, incluida la variante correcta.
  function buildConfirmPanel(item) {
    var left = document.createElement('div');
    left.className = 'kcb-left';

    var confirm = document.createElement('div');
    confirm.className = 'kcb-confirm';

    var kicker = document.createElement('p');
    kicker.className = 'kcb-kicker';
    kicker.textContent = 'Agregado a tu carro';

    // "Primera imagen del producto agregado": cart.js ya devuelve la imagen
    // destacada de la línea, no hace falta ir a buscarla aparte.
    var hero = document.createElement('img');
    hero.className = 'kcb-hero';
    hero.alt = '';
    hero.setAttribute('aria-hidden', 'true');
    if (item && item.image) hero.src = item.image;

    var title = document.createElement('h2');
    title.className = 'kcb-title';
    title.textContent = 'Buena elección.';

    var name = document.createElement('p');
    name.className = 'kcb-added-name';
    name.textContent = (item && (item.product_title || item.title)) || '';

    var price = document.createElement('p');
    price.className = 'kcb-added-price';
    var priceVal = item && typeof item.final_price === 'number' ? item.final_price / 100 : null;
    price.textContent = priceVal != null ? formatPrice(priceVal) : '';

    confirm.appendChild(kicker);
    confirm.appendChild(hero);
    confirm.appendChild(title);
    confirm.appendChild(name);
    confirm.appendChild(price);

    var actions = document.createElement('div');
    actions.className = 'kcb-actions';
    var cartLink = document.createElement('a');
    cartLink.className = 'kcb-btn-primary';
    cartLink.href = '/cart';
    cartLink.textContent = 'Ir al carro';
    actions.appendChild(cartLink);

    left.appendChild(confirm);
    left.appendChild(actions);
    return left;
  }

  /* ------------------------------------------------------------------ */
  /* Cross-sell carousel                                                 */
  /* ------------------------------------------------------------------ */

  // Columna derecha: carrusel VERTICAL. Una barra fina al costado del
  // viewport indica cuánto queda por bajar — se actualiza en cada scroll.
  function buildCrossSellPanel() {
    var el = document.createElement('div');
    el.className = 'kcb-right';
    el.style.display = 'none'; // until we know we have real items

    var kicker = document.createElement('p');
    kicker.className = 'kcb-kicker';
    kicker.textContent = 'También te podría interesar';

    var h3 = document.createElement('h3');
    h3.textContent = 'Completa tu cocina.';

    var carousel = document.createElement('div');
    carousel.className = 'kcb-carousel';

    var viewport = document.createElement('div');
    viewport.className = 'kcb-viewport';
    var list = document.createElement('div');
    list.className = 'kcb-list';
    viewport.appendChild(list);

    var track = document.createElement('div');
    track.className = 'kcb-scrollbar';
    track.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('div');
    thumb.className = 'kcb-scrollbar__thumb';
    track.appendChild(thumb);

    carousel.appendChild(viewport);
    carousel.appendChild(track);

    var more = document.createElement('a');
    more.className = 'kcb-more';
    more.href = '/collections/all';
    more.textContent = 'Ver más productos';

    el.appendChild(kicker);
    el.appendChild(h3);
    el.appendChild(carousel);
    el.appendChild(more);

    function updateScrollbar() {
      var trackHeight = track.clientHeight;
      var scrollable = viewport.scrollHeight - viewport.clientHeight;

      if (scrollable <= 1) {
        // Nada que desplazar (ej. mobile, donde el viewport no tiene límite
        // de alto) — no mostrar una barra que no representa nada.
        track.style.visibility = 'hidden';
        return;
      }
      track.style.visibility = 'visible';

      var ratio = viewport.clientHeight / viewport.scrollHeight;
      var thumbHeight = Math.max(28, trackHeight * ratio);
      var thumbTop = (trackHeight - thumbHeight) * (viewport.scrollTop / scrollable);

      thumb.style.height = thumbHeight + 'px';
      thumb.style.top = thumbTop + 'px';
    }

    viewport.addEventListener('scroll', updateScrollbar);
    // 'scroll' en viewport se limpia solo (el nodo se descarta con el popup),
    // pero 'resize' vive en window y NO se limpia solo — sin destroy() acá,
    // cada apertura del popup deja un listener fantasma apuntando a nodos ya
    // removidos del DOM (memory leak si el usuario agrega varios productos
    // en la misma sesión).
    window.addEventListener('resize', updateScrollbar);
    function destroy() {
      window.removeEventListener('resize', updateScrollbar);
    }

    return { el: el, list: list, viewport: viewport, updateScrollbar: updateScrollbar, destroy: destroy };
  }

  function loadCrossSell(cross, addedItem, onEmpty) {
    if (typeof exponea === 'undefined' || typeof exponea.getRecommendation !== 'function') {
      if (onEmpty) onEmpty();
      return;
    }

    var settled = false;
    // If Bloomreach never answers, don't leave the popup waiting forever.
    var timeout = setTimeout(function () {
      if (!settled) {
        settled = true;
        if (onEmpty) onEmpty();
      }
    }, 6000);

    try {
      // Bloomreach's documented Web SDK contract: a SINGLE options object with
      // the callback inside it (not a second argument).
      exponea.getRecommendation({
        recommendationId: resolveCrossSellRecommendationId(addedItem),
        fillWithRandom: true,
        size: CROSS_SELL_SIZE,
        callback: function (data) {
          if (settled) return;
          settled = true;
          clearTimeout(timeout);

          var items = normalizeRecommendationResponse(data);
          // The popup may already be gone by the time this lands.
          if (!cross.list.isConnected) return;

          items.forEach(function (item) {
            var row = buildCrossSellRow(item);
            if (row) cross.list.appendChild(row);
          });

          if (cross.list.children.length) {
            cross.el.style.display = '';
            // La impresión se emite acá y no al abrir el popup: si Bloomreach
            // no trae nada, la columna de recomendaciones no se muestra, y
            // contarla igual inflaría el denominador del CTR.
            trackCrossSellImpression(addedItem, cross.list.children.length);
            // Síncrono, no requestAnimationFrame: algunos webviews embebidos
            // lo suprimen y la barra quedaría sin medir hasta el primer
            // scroll manual del usuario.
            cross.updateScrollbar();
          } else if (onEmpty) {
            onEmpty();
          }
        },
      });
    } catch (e) {
      settled = true;
      clearTimeout(timeout);
      console.error('[kc-warranty-crosssell-popup] getRecommendation failed', e);
      if (onEmpty) onEmpty();
    }
  }

  // Field names confirmed live against this store's catalog feed — same shape
  // the existing wl-cart banner relies on.
  function normalizeRecommendationResponse(data) {
    if (!Array.isArray(data)) return [];

    return data
      .filter(function (item) {
        return item.active !== false && (item.stock_level == null || item.stock_level > 0);
      })
      .map(function (item) {
        return {
          // Must be a real variant id — item_id/sku would 4xx on /cart/add.js.
          variantId: item.variant_id != null ? String(item.variant_id) : null,
          productId: pick(item, ['product_id', 'item_id']),
          title: pick(item, ['title_combined', 'product_title', 'title']),
          brand: pick(item, ['brand']),
          url: safeUrl(pick(item, ['url'])),
          image: safeUrl(pick(item, ['image'])),
          price: toNumber(pick(item, ['price'])),
          originalPrice: toNumber(pick(item, ['original_price'])),
        };
      })
      .filter(function (item) {
        return item.title && item.image;
      });
  }

  function pick(obj, keys) {
    if (!obj) return null;
    for (var i = 0; i < keys.length; i++) {
      if (obj[keys[i]] != null && obj[keys[i]] !== '') return obj[keys[i]];
    }
    return null;
  }

  function toNumber(v) {
    var n = parseFloat(v);
    return isNaN(n) ? null : n;
  }

  // "impresion" y no "view": en este archivo view ya significa que el cliente
  // hizo clic en la imagen o el nombre para ir al producto. Reusarlo mezclaría
  // clics con exhibiciones en el mismo campo y rompería la lectura histórica
  // del evento. Así el embudo queda impresion > view > add.
  function trackCrossSellImpression(addedItem, productosCount) {
    if (typeof exponea === 'undefined' || typeof exponea.track !== 'function') return;
    try {
      exponea.track('click_carrusel', {
        'ubicación': 'PDP',
        carrusel_name: CROSS_SELL_CARRUSEL_NAME,
        'interés': 'impresion',
        product_name: (addedItem && (addedItem.product_title || addedItem.title)) || '',
        item_id: (addedItem && addedItem.variant_id) || '',
        productos_count: productosCount || 0,
      });
    } catch (e) {
      /* el tracking nunca puede romper la interacción */
    }
  }

  function trackCrossSellClick(interes, item) {
    if (typeof exponea === 'undefined' || typeof exponea.track !== 'function') return;
    try {
      exponea.track('click_carrusel', {
        'ubicación': 'PDP',
        carrusel_name: CROSS_SELL_CARRUSEL_NAME,
        'interés': interes,
        product_name: item.title,
        item_id: item.variantId,
      });
    } catch (e) {
      /* tracking must never break the interaction */
    }
  }

  // Fila de la lista/carrusel vertical: imagen | marca+nombre+precio |
  // "Agregar". Precio: normal (tachado) primero, oferta después, descuento
  // como badge con fondo rojo.
  function buildCrossSellRow(item) {
    var row = document.createElement('div');
    row.className = 'kcb-row';
    // Para tags de Tag Manager basados en clic: los datos del producto quedan
    // en la fila y en el botón. El evento kc:add_cart (kc-add-cart-event.js)
    // trae además sku y product_id confirmados por Shopify.
    var dataset = {
      variantId: item.variantId || '',
      productId: item.productId || '',
      title: item.title || '',
      brand: item.brand || '',
      price: item.price != null ? String(item.price) : '',
    };

    var imgLink = document.createElement('a');
    imgLink.href = item.url || '#';
    imgLink.addEventListener('click', function () {
      trackCrossSellClick('view', item);
    });

    var img = document.createElement('img');
    img.className = 'kcb-row__img';
    img.src = item.image;
    img.alt = item.title;
    img.loading = 'lazy';
    imgLink.appendChild(img);

    var copy = document.createElement('div');
    copy.className = 'kcb-row__copy';

    if (item.brand) {
      var brandEl = document.createElement('span');
      brandEl.className = 'kcb-row__brand';
      brandEl.textContent = item.brand;
      copy.appendChild(brandEl);
    }

    var nameLink = document.createElement('a');
    nameLink.href = item.url || '#';
    nameLink.className = 'kcb-row__name';
    nameLink.textContent = item.title;
    nameLink.addEventListener('click', function () {
      trackCrossSellClick('view', item);
    });
    copy.appendChild(nameLink);

    if (item.price != null) {
      var priceRow = document.createElement('div');
      priceRow.className = 'kcb-prices';
      if (item.originalPrice != null && item.originalPrice > item.price) {
        var discount = Math.round(((item.originalPrice - item.price) / item.originalPrice) * 100);
        priceRow.innerHTML =
          '<span class="kcb-price kcb-price--was">' + formatPrice(item.originalPrice) + '</span>' +
          '<span class="kcb-price">' + formatPrice(item.price) + '</span>' +
          '<span class="kcb-off">-' + discount + '%</span>';
      } else {
        priceRow.innerHTML = '<span class="kcb-price">' + formatPrice(item.price) + '</span>';
      }
      copy.appendChild(priceRow);
    }

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'kcb-btn-outline';
    addBtn.textContent = 'Agregar';
    if (!item.variantId) {
      // No usable variant id — offer the product page instead of a button that
      // would silently fail.
      addBtn.textContent = 'Ver producto';
      addBtn.addEventListener('click', function () {
        trackCrossSellClick('view', item);
        if (item.url) window.location.href = item.url;
      });
    } else {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        addBtn.disabled = true;
        addBtn.textContent = 'Agregando…';
        trackCrossSellClick('add', item);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-KC-Origen': 'cross_sell' },
          body: JSON.stringify({
            items: [{ id: item.variantId, quantity: 1 }],
            // Ask for the rendered sections so the drawer/bubble stay in sync
            // instead of drifting out of date behind the popup.
            sections: ['cart-drawer', 'cart-icon-bubble'],
          }),
        })
          .then(function (r) {
            return r.json().then(function (payload) {
              if (!r.ok) throw new Error(payload && payload.description ? payload.description : 'add failed');
              return payload;
            });
          })
          .then(function (payload) {
            syncCartUi(payload);
            addBtn.textContent = '¡Agregado!';
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.textContent = 'Agregar';
            }, 1800);
          })
          .catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'No disponible';
            setTimeout(function () {
              addBtn.textContent = 'Agregar';
            }, 2500);
          });
      });
    }

    Object.keys(dataset).forEach(function (key) {
      row.dataset[key] = dataset[key];
      addBtn.dataset[key] = dataset[key];
    });

    row.appendChild(imgLink);
    row.appendChild(copy);
    row.appendChild(addBtn);
    return row;
  }

  // Keeps the rest of the theme (drawer contents, count bubble, any cartUpdate
  // subscriber) consistent after an add made outside the normal product form.
  function syncCartUi(payload) {
    try {
      if (payload && payload.sections) {
        var parser = new DOMParser();
        if (payload.sections['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = payload.sections['cart-icon-bubble'];
        }
        if (payload.sections['cart-drawer']) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            var doc = parser.parseFromString(payload.sections['cart-drawer'], 'text/html');
            var incoming = doc.querySelector('#CartDrawer');
            var current = drawer.querySelector('#CartDrawer');
            if (incoming && current) current.innerHTML = incoming.innerHTML;
            drawer.classList.remove('is-empty');
          }
        }
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kc-crosssell-popup', cartData: payload });
      }
    } catch (e) {
      /* UI sync is best-effort — the item is already in the cart */
    }
  }
})();
